import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../../services/apis";

export function* handleAllCommodities() {
  try {
    const res = yield call(API.fetchAllCommodities);
    const { data } = res;
    yield put(actions.fetchCommoditiesSuccess(data));
  } catch (err) {
    yield put(actions.fetchCommoditiesFailure(err?.response?.data));
  }
}

export function* handleOrderCountAnalytic({ payload }) {
  try {
    const res = yield call(API.getLabOrderCountAnalytics, payload);
    const { data } = res;
    yield put(actions.getOrderCountAnalyticSuccess(data));
    payload.onSuccess();
  } catch (err) {
    yield put(actions.getOrderCountAnalyticFailure(err?.response?.data));
    payload.onFailure();
  }
}

export function* handleOrderByStage({ payload }) {
  try {
    const res = yield call(API.getLabOrderByStage, payload);
    const { data } = res;
    yield put(actions.getOrderByStageSuccess(data));
    payload.onSuccess();
  } catch (err) {
    yield put(actions.getOrderByStageFailure(err?.response?.data));
    payload.onFailure();
  }
}

export function* handleCommodityWiseOrders({ payload }) {
  try {
    const res = yield call(API.getLabCommodityWiseOrders, payload);
    const { data } = res;
    yield put(actions.getCommodityWiseOrdersSuccess(data));
    payload.onSuccess();
  } catch (err) {
    yield put(actions.getCommodityWiseOrdersFailure(err?.response?.data));
    payload.onFailure();
  }
}

export function* handleRejectedOrders({ payload }) {
  try {
    const res = yield call(API.getLabRejectedOrders, payload);
    const { data } = res;
    yield put(actions.getRejectedOrdersSuccess(data));
    payload.onSuccess();
  } catch (err) {
    yield put(actions.getRejectedOrdersFailure(err?.response?.data));
    payload.onFailure();
  }
}

export function* handleDisputeAnalysis({ payload }) {
  try {
    const res = yield call(API.getLabDisputeAnalysis, payload);
    const { data } = res;
    yield put(actions.getDisputeAnalysisSuccess(data));
    payload.onSuccess();
  } catch (err) {
    yield put(actions.getDisputeAnalysisFailure(err?.response?.data));
    payload.onFailure();
  }
}

export function* handleReportReviewStatus({ payload }) {
  try {
    const res = yield call(API.getLabReportReviewStatus, payload);
    const { data } = res;
    yield put(actions.getReportReviewStatusSuccess(data));
    payload.onSuccess();
  } catch (err) {
    yield put(actions.getReportReviewStatusFailure(err?.response?.data));
    payload.onFailure();
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export function* labDashboardSaga() {
  yield takeLatest(actions.fetchCommodities.type, handleAllCommodities);
  yield takeLatest(
    actions.getOrderCountAnalytic.type,
    handleOrderCountAnalytic
  );
  yield takeLatest(actions.getOrderByStage.type, handleOrderByStage);
  yield takeLatest(
    actions.getCommodityWiseOrders.type,
    handleCommodityWiseOrders
  );
  yield takeLatest(actions.getRejectedOrders.type, handleRejectedOrders);
  yield takeLatest(actions.getDisputeAnalysis.type, handleDisputeAnalysis);
  yield takeLatest(
    actions.getReportReviewStatus.type,
    handleReportReviewStatus
  );
}
